import React from 'react'
import clsx from 'clsx'
import ReactMarkdown from 'react-markdown'
import {ImgFilters} from '../components/ImgFilters'
import {Tag} from '../components/Tag'
import {TransparencyFeo} from '../components/TransparencyFeo'
import {Accordion, AccordionSummary} from '../components/Accordion'
import {Depositions} from '../components/Depoimentos'
import {
  BreadcrumbItem,
  BreadcrumbLink,
  Breadcrumbs,
  BreadcrumbText,
} from '../components/Breadcrumbs'
import {Typography} from '../components/Typography'
import {Button, Icon} from '../components/Button'
import {useProfessorsQuery} from '../utils/hooks/useProfessorsQuery'
import img01 from '../img/icons/certificado.svg'
import icon14 from '../img/recorrence/icones-feo_valores.svg'
import icon15 from '../img/recorrence/icones-feo_para-quem.svg'
import icon16 from '../img/icons/feo-agenda.svg'
import icon17 from '../img/icons/professores.svg'
import icon19 from '../img/aperfeicoamento.png'
import icon20 from '../img/ead-04.png'
import icon21 from '../img/icons/icones-feo_pre-requisitos.svg'
import icon22 from '../img/icons/icones-feo_informacoes-compiladas.svg'
import icon23 from '../img/icons/feo-beneficios.svg'
import icon24 from '../img/icons/raciocinio.svg'
import icon25 from '../img/icons/feo_filtro.svg'

export const Hero = ({className, imgDesktop, imgMobile}) => {
  const style = clsx(`relative w-full h-40 mb-4`, className)
  return (
    <div className={style}>
      <ImgFilters img={imgMobile} transparency className="lg:hidden" />
      <ImgFilters
        img={imgDesktop}
        transparency
        imgPosition="bg-center"
        className="hidden lg:block"
      />
    </div>
  )
}

export const CardMec = ({calltoAction, hotMktLink}) => (
  <div className="relative lg:absolute lg:w-56 lg:h-60 lg:-top-32 lg:right-0">
    <div className="relative pt-5 pb-12 mb-10 card-mec bg-gray-75 px-9 lg:pb-14 rounded-md">
      <div className="flex flex-row lg:flex-col lg:text-center lg:justify-center lg:items-center">
        <div
          className="flex items-center justify-center bg-white rounded-full shadow-md card-mec-circle lg:mb-4"
          style={{height: '90px'}}
        >
          <img src={img01} alt="" />
        </div>
        <div className="pl-8 lg:p-0">
          <Typography
            className="lg:text-center"
            variant="heading2"
            weight="legal"
          >
            Pós-Graduação reconhecida pelo
          </Typography>
          <Typography
            variant="heading-xl"
            className="uppercase lg:text-center"
            color="blue-500"
          >
            MEC
          </Typography>
        </div>
      </div>
      <div className="absolute bottom-0 card-mec-button left-1/2 transform translate-y-1/2 -translate-x-1/2">
        <Button
          as="a"
          className="uppercase lg:w-full"
          size="sm:text-sm lg:text-base"
          href={hotMktLink}
          target="_blank"
        >
          {calltoAction}
        </Button>
      </div>
    </div>
  </div>
)

const Comment = ({message, author, authorStatus}) => (
  <div className="overflow-hidden lg:overflow-auto">
    <div className={clsx('mx-auto max-w-screen-lg relative')}>
      <div className="relative z-10 px-10 mt-4 mb-28 lg:mb-8">
        <Typography
          className="italic ml-2.5"
          size="lg"
          color="gray-900"
          weight="light"
          style={{maxWidth: '644px'}}
        >
          <Typography
            as="span"
            weight="bold"
            variant="heading-xl"
            style={{marginLeft: '-10px'}}
          >
            "
          </Typography>
          {message}"
        </Typography>
        <Typography as="span" className="ml-2.5">
          <a href="">
            <Typography
              as="span"
              weight="bold"
              className="underline uppercase"
              color="blue-100"
            >
              {author}
            </Typography>
          </a>{' '}
          | {authorStatus}
        </Typography>
      </div>
    </div>
    <div
      className="relative w-96 h-96 lg:w-100 lg:h-100 lg:absolute lg:-right-44 lg:top-40"
      style={{zIndex: '-1'}}
    >
      <div className="absolute comment-image">
        <img className="w-full" src={icon20} alt="" />
      </div>
    </div>
  </div>
)

const DisplayVideo = ({link}) => {
  const getLinkPlayer = React.useMemo(() => {
    const {id} = link.match(/http?s:\/\/vimeo.com\/(?<id>[0-9]+)/)?.groups ?? {}

    return `https://player.vimeo.com/video/${id}`
  }, [link])

  return (
    <div className="relative w-full my-6">
      <div className="absolute w-full bg-blue-100 shadow-lg -top-3 rounded-md lg:left-3 h-14"></div>
      <div className="absolute w-full bg-blue-100 shadow-lg -bottom-3 rounded-md lg:-left-3 h-14"></div>
      <div className="relative z-10 w-full py-6 bg-white shadow-lg h-44 lg:h-102 lg:py-12">
        <iframe
          className="w-full h-full"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; fullscreen"
          src={getLinkPlayer}
        ></iframe>
      </div>
    </div>
  )
}

const DisplayVideos = ({videos = []}) => {
  return <DisplayVideo link={videos[0].link} />
}

const Investment = ({
  investmentOldValue = '19,99',
  investmentValue = '9,99',
  calltoAction = 'Quero me inscrever',
  hotMktLink = '',
}) => {
  return (
    <div className="container relative px-10 overflow-hidden shadow-2xl shadow-inner lg:px-auto">
      <div className={clsx('mx-auto max-w-screen-lg relative')}>
        <section className="relative z-10 py-10">
          <div className="p-3 rounded-lg shadow-lg lg:max-w-5xl lg:p-5 relative grid gap-2.5 grid-cols-4 grid-flow-col lg:grid-cols-12 lg:gap-4 bg-white">
            <div className="pb-5 border-gray-500 lg:pb-0 col-start-1 col-end-5">
              <div className="flex">
                <div className="flex items-center">
                  <Icon icon={icon14} />
                </div>
                <div className="ml-5">
                  <Typography
                    as="p"
                    size="lg"
                    className="font-black uppercase color-gray-900"
                  >
                    INVESTIMENTO
                  </Typography>
                  <Typography
                    as="p"
                    className="max-w-xs font-black uppercase color-gray-900"
                  >
                    Pagamento facilitado e acesso por 18 meses
                  </Typography>
                </div>
              </div>
              <div className="mt-4">
                <Typography className="line-through uppercase">
                  de R$ {investmentOldValue}
                </Typography>
              </div>
              <div>
                <Typography uppercase weight="black">
                  Por apenas R${' '}
                  <Typography as="span" size="xl" weight="black">
                    {investmentValue}
                  </Typography>
                </Typography>
              </div>
            </div>
            <div className="mt-5 lg:mt-0 lg:pl-5 col-start-1 col-end-5 lg:col-start-5 lg:col-end-11">
              <div className="flex">
                <div>
                  <Icon icon={icon15} />
                </div>
                <div className="items-center ml-5 grid">
                  <Typography
                    as="p"
                    size="lg"
                    className="font-black uppercase color-gray-900"
                  >
                    PARA QUEM?
                  </Typography>
                </div>
              </div>
              <div className="mt-4">
                <Typography className="max-w-xs">
                  <Typography as="strong" weight="black" uppercase>
                    Estudantes
                  </Typography>{' '}
                  e{' '}
                  <Typography as="strong" weight="black" uppercase>
                    profissionais de fisioterapia
                  </Typography>{' '}
                  que trabalham com pacientes com dor.
                </Typography>
              </div>
            </div>
            <div className="text-center col-start-1 col-end-5 lg:col-start-1 lg:col-end-11 lg:text-left">
              <div className="lg:absolute lg:right-0 lg:top-1/2 transform translate-y-7 lg:translate-x-2/4 lg:-translate-y-4">
                <Button as="a" className="uppercase p-9" href={hotMktLink}>
                  {calltoAction}
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="absolute inset-0 z-0 w-full h-full overflow-hidden bg-right bg-no-repeat bg-cover">
        <TransparencyFeo
          className="absolute h-full -right-0 transform opacity-30 scale-300"
          color="#0095da"
        />
      </div>
    </div>
  )
}

const ProfessorProfile = ({professors}) => (
  <div className="grid grid-cols-1 gap-2.5 lg:gap-4 lg:grid-cols-3">
    {professors.map(professor => (
      <div className="flex flex-col items-center mt-4">
        <div>
          <img
            src={professor?.photo}
            alt=""
            className="object-cover object-top rounded-full w-22 h-22"
          />
        </div>
        <div className="mt-4">
          <Typography weight="bold">{professor?.name}</Typography>
        </div>
        <div className="mt-4">
          <Button
            as="a"
            background="bg-gray-100"
            href={professor?.link}
            target="_blank"
          >
            VEJA A PÁGINA DO PROFº
          </Button>
        </div>
      </div>
    ))}
  </div>
)

const Bullets = ({list = []}) => {
  return (
    <ul className="list-disc-blue">
      {list.map(topic => {
        const title = topic.title || topic.subTitle
        const description = topic.description
        return (
          <li className="ml-10">
            <dt className="inline-block">
              <Typography
                className="mt-4 uppercase leading-8"
                weight="black"
                color="blue-500"
              >
                {title}
              </Typography>
            </dt>
            <dd className="pl-6">
              <Typography className="leading-8">{description}</Typography>
            </dd>
          </li>
        )
      })}
    </ul>
  )
}

const components = {
  ul: ({children}) => (
    <ul className="pl-10 list-disc-blue space-y-4">{children}</ul>
  ),
  strong: ({children}) => {
    return (
      <Typography as="strong" weight="black">
        {children}
      </Typography>
    )
  },
  li: ({children}) => {
    return <Typography as="li">{children}</Typography>
  },
}
const SectionProgramContent = ({
  workload,
  requirements,
  method,
  marketDemand,
  content,
  developmentSkills,
  professors,
}) => {
  const allProfessors = useProfessorsQuery()

  const professorsObj = professors.map(name => {
    return allProfessors.find(p => p.name === name)
  })

  return (
    <div className={clsx('mx-auto max-w-screen-lg my-10 px-10')}>
      <Accordion>
        <AccordionSummary
          title="Carga Horária"
          subtitle={`${workload.classByModule}, ${workload.totalHours}`}
          icon={icon16}
          disabled={true}
        />
      </Accordion>
      <Accordion>
        <AccordionSummary title="pré-requisitos" icon={icon21} />
        <div>
          <Typography className="leading-8">{requirements.details}</Typography>
          <Bullets list={requirements.topics} />
        </div>
      </Accordion>
      <Accordion>
        <AccordionSummary title="metodologia" icon={icon24} />
        <Typography className="leading-8">{method.details}</Typography>
      </Accordion>
      <Accordion>
        <AccordionSummary
          title="demanda do mercado alinhadas ao curso"
          icon={icon23}
        />
        <Typography className="leading-8">{marketDemand.details}</Typography>
      </Accordion>
      <Accordion>
        <AccordionSummary title="conteúdo programático" icon={icon25} />
        <div>
          {content.map(item => (
            <>
              <Typography weight="black" className="pt-6">
                {item.contentTitle}
              </Typography>
              <Bullets list={item.contentTopics} />
            </>
          ))}
        </div>
      </Accordion>
      <Accordion>
        <AccordionSummary
          title="desenvolvimento de habilidades"
          icon={icon22}
        />
        <ReactMarkdown components={components}>
          {developmentSkills}
        </ReactMarkdown>
      </Accordion>
      <Accordion>
        <AccordionSummary title="Professores" icon={icon17} />
        <ProfessorProfile professors={professorsObj} />
      </Accordion>
    </div>
  )
}

const CardsPlatformAndPos = ({list}) => {
  return (
    <div className={clsx('mx-auto max-w-screen-lg my-10 px-10')}>
      <Typography variant="heading-xl" color="blue-500" className="text-center">
        Veja Também:
      </Typography>

      <div className="grid grid-cols-1 gap-2.5 lg:gap-4 lg:grid-cols-3">
        {list.map(item => (
          <div className="shadow-lg">
            <div
              className="pb-4 mt-6"
              style={{borderBottom: '1px solid #bdbdbd'}}
            >
              <div className="relative mb-5">
                <img className="w-full" src={item.photo} alt="" />
                {item.tagType.type === 'platform' && (
                  <Tag
                    className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    variant="purple"
                  >
                    {item.tagType.description}
                  </Tag>
                )}
                {item.tagType.type === 'pos' && (
                  <Tag className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    {item.tagType.description}
                  </Tag>
                )}
              </div>
              <div className="px-4">
                <Typography variant="heading2" color="blue-500">
                  {item.title}
                </Typography>
                {item.professors.length === 1 && (
                  <Typography className="uppercase">
                    {item.professors[0]}
                  </Typography>
                )}
                {item.professors.length > 1 && (
                  <Typography>VÁRIOS PROFESSORES</Typography>
                )}
              </div>
              {item.tagType.type === 'pos' && (
                <div className="px-4">
                  <Typography className="line-through uppercase">
                    De R$ {item.price.oldValue}
                  </Typography>
                  <Typography className="uppercase" weight="bold">
                    Por apenas 12x R${' '}
                    <Typography as="span" size="2xl" weight="bold">
                      {item.price.currentValue}
                    </Typography>
                  </Typography>
                </div>
              )}
              {item.tagType.type === 'platform' && (
                <div className="px-4 mt-20">
                  <Button className="w-full uppercase" background="bg-gray-100">
                    CONHEÇA o plano anual!
                  </Button>
                </div>
              )}
            </div>
            <div className="flex items-center justify-center p-4">
              <Button className="w-full">DETALHES DO CURSO</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const Page = ({
  heroBannerSingle,
  title,
  quote,
  videos,
  investiment,
  workload,
  requirements,
  method,
  marketDemand,
  content,
  developmentSkills,
  professors,
  ...props
}) => {
  const programContent = {
    workload,
    requirements,
    method,
    marketDemand,
    content,
    developmentSkills,
    professors,
  }
  return (
    <div>
      <Hero {...heroBannerSingle} />
      <div className={clsx('mx-auto max-w-screen-lg relative')}>
        <div className={clsx('mx-auto max-w-screen-lg relative')}>
          <div className="px-10">
            <Breadcrumbs>
              <BreadcrumbItem>
                <BreadcrumbLink active>Pos Graduação</BreadcrumbLink> /{' '}
                <BreadcrumbText>{title}</BreadcrumbText>
              </BreadcrumbItem>
            </Breadcrumbs>
            <Tag className="my-4">Pós Graduação</Tag>
            <Typography
              className="mb-4 uppercase lg:text-6xl"
              variant="heading-3xl"
              color="blue-500"
              style={{maxWidth: '730px'}}
            >
              {title}
            </Typography>
          </div>
          <CardMec {...investiment} />
        </div>
        <Comment {...quote} />
      </div>
      <div className={clsx('mx-auto max-w-screen-lg relative')}>
        <div className="px-10">
          <DisplayVideos videos={videos} />
        </div>
      </div>
      <Investment {...investiment} />
      <SectionProgramContent {...programContent} />
      <Depositions />
    </div>
  )
}

const Template = ({pageContext}) => {
  return <Page {...pageContext?.frontmatter} />
}

export default Template
